import gql from "graphql-tag";
import { Location } from "../../api/schema";

export interface ProductGroupListResponse {
  productGroups: Array<Location>;
}

export interface DeleteProductGroupResponse {
  deleteProductGroup: boolean;
}

export interface CreateProductGroupResponse {
  createProductGroup: { id: number };
}

export interface UpdateProductGroupResponse {
  updateProductGroup: { id: number };
}

export const ProductGroupListQuery = gql`
  query locations {
    productGroups {
      id
      name
      parent {
        id
        name
        parent {
          id
          name
          parent {
            id
            name
          }
        }
      }
    }
  }
`;

export const CreateProductGroupMutation = gql`
  mutation createProductGroup($values: CreateProductGroupInput!) {
    createProductGroup(values: $values) {
      id
    }
  }
`;

export const UpdateProductGroupMutation = gql`
  mutation updateProductGroup($values: UpdateProductGroupInput!) {
    updateProductGroup(values: $values) {
      id
    }
  }
`;

export const DeleteProductGroupMutation = gql`
  mutation deleteProductGroup($id: ID!) {
    deleteProductGroup(id: $id)
  }
`;
